/**
 * AdminCommandCenterDashboardSorteosAlertasView — Web Component (Light DOM)
 *
 * Vista principal (Dashboard) del panel de administración.
 * Contiene:
 *   - Alertas Operativas: sistema de notificaciones colapsable.
 *   - KPI Grid: métricas en tiempo real (Apostado, Pagado, Margen, RTP).
 *   - Info Bar: estatus de dispositivos y próximos sorteos.
 *   - Sorteos: lista filtrable y buscador de sorteos recientes.
 * Migrado desde index.html (sección Command Center).
 */
import { t } from '../../services/i18n-admin.js';
import { icon } from '../../utils/icon.js';

export class AdminCommandCenterDashboardSorteosAlertasView extends HTMLElement {
    connectedCallback() {
        this.innerHTML = `
                    <!-- COMMAND CENTER VIEW -->
                    <section class="view active" id="view-command-center">
                        <!-- ALERTAS OPERATIVAS (Colapsable) -->
                        <div id="alertasContainer" class="alertas-container" style="display: none; margin-bottom: 16px">
                            <div
                                class="alertas-header"
                                style="
                                    display: flex;
                                    align-items: center;
                                    gap: 8px;
                                    padding: 10px 12px;
                                    background: rgba(255, 152, 0, 0.1);
                                    border-radius: 8px;
                                    user-select: none;
                                }
                            "
                            >
                                <div
                                    style="display: flex; align-items: center; gap: 8px; flex: 1; cursor: pointer"
                                    data-action="app:toggleAlertas"
                                >
                                    <img
                                        src="/assets/icons/bell.svg"
                                        class="icon"
                                        alt=""
                                        style="color: var(--accent-orange)"
                                    />
                                    <span style="font-weight: 600; color: var(--accent-orange)"
                                        >${t('Alertas Operativas')}</span
                                    >
                                    <span id="alertasCount" class="badge badge-warning" style="font-size: 11px">0</span>
                                </div>
                                <button
                                    class="btn-icon"
                                    data-action="app:openAlertasConfig"
                                    title="${t('Configurar alertas')}"
                                    style="
                                        padding: 4px;
                                        background: transparent;
                                        border: none;
                                        cursor: pointer;
                                        opacity: 0.7;
                                    "
                                >
                                    <img
                                        src="/assets/icons/settings.svg"
                                        class="icon"
                                        alt=""
                                        style="width: 16px; height: 16px"
                                    />
                                </button>
                                <img
                                    id="alertasChevron"
                                    src="/assets/icons/chevron-down.svg"
                                    class="icon"
                                    alt=""
                                    data-action="app:toggleAlertas"
                                    style="transition: transform 0.2s; cursor: pointer; transform: rotate(-90deg)"
                                />
                            </div>
                            <div
                                id="alertasList"
                                class="alertas-list"
                                style="
                                    display: none;
                                    flex-wrap: wrap;
                                    gap: 8px;
                                    margin-top: 8px;
                                    max-height: 200px;
                                    overflow-y: auto;
                                }
                            "
                            ></div>
                        </div>

                        <div id="ccTimelineBar" class="cc-timeline-bar"></div>

                        <!-- VISTA OPERATIVA (solo no-superadmin): la puebla
                             App.loadCommandCenter() cuando la respuesta del
                             command-center trae data.vistaOperativa -->
                        <div id="ccOperativo" style="display: none; margin-bottom: 16px"></div>

                        <div class="kpi-grid kpi-grid--3col">
                            <div class="kpi-card">
                                <div class="kpi-label">${t('Ingresado')}</div>
                                <div class="kpi-value green" id="kpiIngresado"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                            </div>
                            <div class="kpi-card">
                                <div class="kpi-label">${t('Cobrado')}</div>
                                <div class="kpi-value red" id="kpiCobrado"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                            </div>
                            <div class="kpi-card">
                                <div class="kpi-label">${t('GGR')}</div>
                                <div class="kpi-value" id="kpiMargen"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                            </div>
                        </div>
                        <div class="kpi-grid kpi-grid--3col" style="margin-top:8px;">
                            <div class="kpi-card">
                                <div class="kpi-label">${t('Jugado')}</div>
                                <div class="kpi-value blue" id="kpiApostado"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                            </div>
                            <div class="kpi-card">
                                <div class="kpi-label">${t('Premiado')}</div>
                                <div class="kpi-value orange" id="kpiPagado"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                            </div>
                            <div class="kpi-card">
                                <div class="kpi-label">${t('RTP')}</div>
                                <div class="kpi-value orange" id="kpiRTP"><span class="skeleton-bar" style="display:inline-block;width:50px;height:20px;"></span></div>
                            </div>
                        </div>
                        <!-- KPIs secundarios de pasarela: explican la diferencia entre
                             lo solicitado y lo que el banco realmente movió. "Cobrado"
                             arriba ya es el neto pagado; estos desglosan los retiros que
                             NO salieron (banco los rechazó) y los que se devolvieron al
                             saldo del jugador. -->
                        <div class="kpi-grid kpi-grid--3col" style="margin-top:8px;">
                            <div class="kpi-card">
                                <div class="kpi-label">${t('Rechazados')}</div>
                                <div class="kpi-value" id="kpiRejeitados"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                            </div>
                            <div class="kpi-card">
                                <div class="kpi-label">${t('Compensados')}</div>
                                <div class="kpi-value" id="kpiCompensados"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                            </div>
                            <div class="kpi-card">
                                <div class="kpi-label">${t('En proceso')}</div>
                                <div class="kpi-value" id="kpiEnVuelo"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                            </div>
                        </div>

                        <div class="cc-info-bar">
                            <div class="cc-info-item">
                                ${icon('users')}
                                <span><span id="ccJugadoresOnline">0</span> ${t('Jugadores online')}</span>
                            </div>
                            <div class="cc-info-item" title="${t('TV (pantallas) + POS (cajas) conectados')}">
                                ${icon('monitor')}
                                <span><span id="ccAparatosOnline">0</span> ${t('Aparatos')} <span class="cc-info-desglose" id="ccAparatosDesglose"></span></span>
                            </div>
                            <div class="cc-info-item">
                                ${icon('activity')}
                                <span>${t('Proximo sorteo:')} <span id="ccProximoSorteo">--</span></span>
                            </div>
                            <div class="cc-info-item">
                                ${icon('list')}
                                <span>${t('Sorteos (período):')} <span id="ccSorteosHoy">0</span></span>
                            </div>
                        </div>

                        <!-- TABS del dashboard: Red (analítica de quién produce) +
                             Sorteos (listado operativo). El rango del timeline-bar de
                             arriba alimenta ambas. -->
                        <div class="cc-dash-tabs" role="tablist">
                            <button class="cc-dash-tab active" data-cc-tab="red" role="tab">${t('Red')}</button>
                            <button class="cc-dash-tab" data-cc-tab="promos" role="tab">${t('Promos')}</button>
                            <button class="cc-dash-tab" data-cc-tab="sorteos" role="tab">${t('Sorteos')}</button>
                        </div>

                        <!-- PANEL RED: analítica de red de venta (charts premium) -->
                        <div class="cc-dash-panel" data-cc-panel="red" id="ccDashRed"></div>

                        <!-- PANEL PROMOS: resumen de salud de cada promo (linkea al detalle en Marketing) -->
                        <div class="cc-dash-panel" data-cc-panel="promos" id="ccDashPromos" style="display:none"></div>

                        <!-- PANEL SORTEOS: lo existente, envuelto (oculto por defecto;
                             la tab Red es la vista por defecto del dashboard) -->
                        <div class="cc-dash-panel" data-cc-panel="sorteos" style="display:none">
                        <div class="section-header" style="flex-wrap: wrap; gap: 12px">
                            <h3 class="section-title">${t('Sorteos')}</h3>
                            <div
                                class="sorteos-filters"
                                style="display: flex; gap: 8px; align-items: center; flex-wrap: wrap"
                            >
                                <select
                                    id="sorteoConfigSelect"
                                    class="filter-select"
                                    style="min-width: 130px; padding: 6px 10px; font-size: 13px"
                                    data-action="app:changeSorteoConfig"
                                >
                                    <option value="all">${t('Todos')}</option>
                                </select>
                                <select
                                    id="sorteoRangeSelect"
                                    class="filter-select"
                                    style="min-width: 110px; padding: 6px 10px; font-size: 13px"
                                    data-action="app:changeSorteoRange"
                                >
                                    <option value="20">${t('Últimos 20')}</option>
                                    <option value="50">${t('Últimos 50')}</option>
                                    <option value="100">${t('Últimos 100')}</option>
                                    <option value="200">${t('Últimos 200')}</option>
                                    <option value="hoy">${t('Hoy')}</option>
                                    <option value="semana">${t('Semana')}</option>
                                    <option value="mes">${t('Mes')}</option>
                                </select>
                                <input
                                    type="text"
                                    id="sorteoSearchInput"
                                    class="form-input"
                                    placeholder="${t('Buscar...')}"
                                    style="width: 110px; padding: 6px 10px; font-size: 13px"
                                    data-action="app:filterSorteos"
                                />
                                <div class="filter-chips" style="display: flex; gap: 6px">
                                    <button
                                        class="chip-filter"
                                        data-filter="conApuestas"
                                        data-action="app:toggleSorteoFilter"
                                        data-param="conApuestas"
                                    >
                                        ${t('Con apuestas')}
                                    </button>
                                    <button
                                        class="chip-filter"
                                        data-filter="casaGana"
                                        data-action="app:toggleSorteoFilter"
                                        data-param="casaGana"
                                    >
                                        ${t('Casa +')}
                                    </button>
                                    <button
                                        class="chip-filter"
                                        data-filter="casaPierde"
                                        data-action="app:toggleSorteoFilter"
                                        data-param="casaPierde"
                                    >
                                        ${t('Casa -')}
                                    </button>
                                </div>
                                <span
                                    id="sorteoFilterCount"
                                    style="font-size: 12px; color: var(--text-secondary); margin-left: 8px"
                                ></span>
                            </div>
                        </div>
                        <!-- Comparativa premium por sorteo: jugadas / premios / RTP -->
                        <div id="ccSorteosKpis"></div>
                        <div class="sorteos-list" id="sorteosList"></div>
                        </div><!-- /cc-dash-panel sorteos -->
                    </section>
        `;
    }
}

customElements.define(
    'admin-command-center-dashboard-sorteos-alertas-view',
    AdminCommandCenterDashboardSorteosAlertasView
);
